export default function AccountIcon({accountType}) {
  return <i className={`bi bi=${accountIconClass(accountType)} me-2`}/>
}

export function accountIconClass(accountType) {
  if(accountType === 'credit_card') {
    return "credit-card"
  }
  else if(accountType === 'checking') {
    return "cash"
  }
  else if(accountType === 'savings') {
    return "piggy-bank"
  }
  else {
    return "cash-stack"
  }
}